import type { UploadStatus } from "@canvas-sync/shared";
import { uploadStatusLabel } from "../lib/labels";

/**
 * Visual mapping for the upload lifecycle. Reuses the same badge palette
 * as runs (queued/running/success/failed/cancelled) plus one new variant
 * (`warn`) so partial-success states (IMPORTED_WITH_MESSAGES,
 * FAILED_WITH_MESSAGES) read at a glance.
 */
const variants: Record<UploadStatus, { className: string; pulse: boolean }> = {
  SUBMITTING: { className: "badge badge-queued", pulse: true },
  SUBMITTED: { className: "badge badge-running", pulse: true },
  IMPORTING: { className: "badge badge-running", pulse: true },
  IMPORTED: { className: "badge badge-success", pulse: false },
  IMPORTED_WITH_MESSAGES: { className: "badge badge-warn", pulse: false },
  FAILED_WITH_MESSAGES: { className: "badge badge-failed", pulse: false },
  FAILED: { className: "badge badge-failed", pulse: false },
  ABORTED: { className: "badge badge-cancelled", pulse: false },
  ERROR: { className: "badge badge-failed", pulse: false },
};

export function UploadStatusBadge({ status }: { status: UploadStatus }) {
  const v = variants[status];
  return (
    <span className={v.className}>
      {v.pulse && <span className="badge-pulse" />}
      {uploadStatusLabel(status)}
    </span>
  );
}
